<template>
    <div>
        <div
            v-cloak
            class="row"
        >
            <div class="col-xs-12">
                <div class="box box-primary">
                    <div class="box-header with-border">
                        <h3 class="box-title">Info</h3>
                        <div class="box-tools pull-right">
                            <button
                                class="btn btn-box-tool"
                                title="Collapse"
                                type="button"
                                @click="toggleCollapse"
                            >
                                <i
                                    :class="changeIcon(collapse)"
                                    class="fa"
                                ></i>
                            </button>
                        </div>
                    </div>
                    <!-- /.box-header -->
                    <vue-slide-up-down
                        :active="collapse"
                        :duration="durationCollapse"
                    >
                        <div>
                            <div
                                v-if="category.id"
                                class="box-body"
                            >
                                <div class="row">
                                    <div class="col-xs-12 col-sm-6 col-md-3">
                                        <strong>Name:</strong>
                                        <p>{{ category.name }}</p>
                                    </div>
                                    <div class="col-xs-12 col-sm-6 col-md-3">
                                        <strong>Lists:</strong>
                                        <p>
                                            <BadgeTotal
                                                :value="category.lists_count"
                                                color="gray"
                                                title="Total"
                                            />
                                            <BadgeTotal
                                                :value="category.lists_active"
                                                color="green"
                                                title="Active"
                                            />
                                            <BadgeTotal
                                                :value="category.lists_inactive"
                                                color="red"
                                                title="Inactive"
                                            />
                                        </p>
                                    </div>
                                    <div class="col-xs-12 col-sm-6 col-md-3">
                                        <strong>Created At:</strong>
                                        <p>{{ category.created_at }}</p>
                                    </div>
                                    <div class="col-xs-12 col-sm-6 col-md-3">
                                        <strong>Updated At:</strong>
                                        <p>{{ category.updated_at }}</p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-xs-12 col-sm-6 col-md-3">
                                        <strong>Messages:</strong>
                                        <p v-show="!isLoaded">
                                            <img
                                                alt="Preloader"
                                                class="table-row-preloader"
                                                rel="preload"
                                                src="/img/table-row-preloader.gif"
                                            />
                                        </p>
                                        <p v-show="isLoaded">
                                            <BadgeTotal
                                                :value="category.messages_count"
                                                color="gray"
                                                title="Total"
                                            />
                                            <BadgeTotal
                                                :value="category.messages_sent"
                                                color="green"
                                                title="Sent"
                                            />
                                            <BadgeTotal
                                                :value="category.messages_failed"
                                                color="red"
                                                title="Failed"
                                            />
                                            <BadgeTotal
                                                :value="category.messages_blacklisted"
                                                color="black"
                                                title="Blacklisted"
                                            />
                                        </p>
                                    </div>
                                    <div class="col-xs-12 col-sm-6 col-md-3">
                                        <strong>Clicks:</strong>
                                        <p v-show="!isLoaded">
                                            <img
                                                alt="Preloader"
                                                class="table-row-preloader"
                                                rel="preload"
                                                src="/img/table-row-preloader.gif"
                                            />
                                        </p>
                                        <p v-show="isLoaded">
                                            <BadgeTotal
                                                :value="category.percentage + '%'"
                                                color="light-blue"
                                                title="Percentage"
                                            />
                                            <BadgeTotal
                                                :value="category.clicks_count"
                                                color="aqua-active"
                                                title="Count"
                                            />
                                        </p>
                                    </div>
                                    <div class="col-xs-12 col-sm-6 col-md-3">
                                        <strong>Revenue:</strong>
                                        <p v-show="!isLoaded">
                                            <img
                                                alt="Preloader"
                                                class="table-row-preloader"
                                                rel="preload"
                                                src="/img/table-row-preloader.gif"
                                            />
                                        </p>
                                        <p v-show="isLoaded">
                                            <BadgeTotal
                                                :value="'$' + category.revenues_prepared_value"
                                                color="light-blue"
                                                title="Amount"
                                            />
                                            <BadgeTotal
                                                :value="category.revenues_count"
                                                color="aqua-active"
                                                title="Count"
                                            />
                                        </p>
                                    </div>
                                    <div class="col-xs-12 col-sm-6 col-md-3">
                                        <strong>Contacts:</strong>
                                        <p v-show="!isLoaded">
                                            <img
                                                alt="Preloader"
                                                class="table-row-preloader"
                                                rel="preload"
                                                src="/img/table-row-preloader.gif"
                                            />
                                        </p>
                                        <p v-show="isLoaded">
                                            <span v-if="category.contacts_count">
                                                <BadgeTotal
                                                    :value="category.contacts_count"
                                                    color="gray"
                                                    title="Total"
                                                />
                                                <BadgeTotal
                                                    :value="category.contacts_active"
                                                    color="green"
                                                    title="Active"
                                                />
                                                <BadgeTotal
                                                    :value="category.contacts_inactive"
                                                    color="red"
                                                    title="Inactive"
                                                />
                                            </span>
                                            <span v-else>
                                                <BadgeTotal
                                                    value="0"
                                                    color="red"
                                                    title="Total"
                                                />
                                            </span>
                                        </p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-xs-12 col-sm-6 col-md-3">
                                        <strong>Unsubscribes:</strong>
                                        <p v-show="!isLoaded">
                                            <img
                                                alt="Preloader"
                                                class="table-row-preloader"
                                                rel="preload"
                                                src="/img/table-row-preloader.gif"
                                            />
                                        </p>
                                        <p v-show="isLoaded">
                                            <BadgeTotal
                                                :value="category.unsubscribes_percent + '%'"
                                                color="light-blue"
                                                title="Percentage"
                                            />
                                            <BadgeTotal
                                                :value="category.unsubscribes_count"
                                                color="aqua-active"
                                                title="Count"
                                            />
                                        </p>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-xs-12 col-sm-6 col-md-3">
                                        <strong>Group:</strong>
                                        <p>
                                            <a
                                                :href="getRouteGroup(category.group.id)"
                                                :title="category.group.name"
                                                >{{ category.group.name }}</a
                                            >
                                        </p>
                                    </div>
                                    <div class="col-xs-12 col-sm-6 col-md-9">
                                        <strong>Tags:</strong>
                                        <p v-if="category.tags.length">
                                            <span
                                                v-for="(tag, index) in category.tags"
                                                :key="index"
                                            >
                                                <a
                                                    :href="getRouteCategory(tag.id)"
                                                    :title="tag.name"
                                                >
                                                    {{ tag.name }}
                                                </a>
                                                <span v-if="index !== category.tags.length - 1">, </span>
                                            </span>
                                        </p>
                                        <p v-else>
                                            <em class="text-info">None</em>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </vue-slide-up-down>
                </div>
            </div>
        </div>
        <FilterDataSelector :enable-filter="isDisabledFilter()" />
        <CarrierTemplateComponent
            :carriers="carriers"
            :is-carriers-fetching="isCarriersFetching"
            :toggle-btn="getCarriers"
        />
        <OffersTemplateComponent
            :category-id="categoryId"
            :is-offers-fetching="isOffersFetching"
            :offers-data="offers"
            :toggle-btn="getOffers"
        />
        <TemplateComponent
            :entity-id="categoryId"
            :entity-name="'categories'"
            :query-filter="filter"
        />
    </div>
</template>

<script>
import BadgeTotal from '../../subcomponents/BadgeTotal';
import FilterDataSelector from '../../subcomponents/FilterDataSelector';
import CarrierTemplateComponent from '../templates/CarrierTemplateComponent';
import OffersTemplateComponent from '../templates/OffersTemplateComponent';
import TemplateComponent from '../templates/TemplateComponent';
import EventBus from '../../../event-bus';

export default {
    components: {
        BadgeTotal,
        FilterDataSelector,
        CarrierTemplateComponent,
        OffersTemplateComponent,
        TemplateComponent,
    },

    props: {
        categoryId: {
            type: Number,
            default: null,
        },
    },

    data: function () {
        return {
            category: {},
            categoryStats: {},
            offers: [],
            btnToggle: {},
            carriers: [],
            lists: {},
            listsStats: {},
            ListsStatus: {},
            countryTypes: {},
            offersIds: [],
            disableProps: {
                disableBtn: 'disable-btn',
                disableWrapper: 'disable-wrapper',
                preventEnterFilter: true,
            },
            isLoaded: false,
            isLoadedOffersStats: false,
            isCarriersFetching: false,
            isOffersFetching: false,
            isUserOrPublisher: true,
            isAdminOrPublisher: false,
            pageNumber: this.$route.query.page,
            pageID: this.$route.params.id,
            route: {
                group: '/category-groups/:id:',
                tag: '/lists/categories/tags/:id:',
            },
            getOffers: false,
            getCarriers: false,
            disableFilterCarriers: false,
            disableFilterOffers: false,
            disableFilterLists: false,
            collapse: true,
            durationCollapse: 700,
        };
    },

    computed: {
        filter: function () {
            return this.$route.query['filter[dates]'] ? '?' + encodeURI('filter[dates]=' + this.$route.query['filter[dates]']) : '';
        },
    },

    watch: {
        filter: function () {
            this.isOffersFetching = false;
            this.isCarriersFetching = false;
            if (this.$route.query['filter[dates]']) {
                this.getCarriers = true;
                this.getOffers = true;
                this.getStatsCarriers(this.categoryId);
                this.getStatsOffers(this.categoryId);
            } else {
                this.carriers = [];
                this.offers = [];
                this.getCarriers = false;
                this.getOffers = false;
            }
        },
    },

    created() {
        EventBus.$on('clicksOffers', (data) => {
            this.getOffers = data.getOffers;
            if (!this.offers.length) {
                this.getStatsOffers(this.categoryId);
            }
        });
        EventBus.$on('clicksCarriers', (data) => {
            this.getCarriers = data.getCarriers;
            if (!this.carriers.length) {
                this.getStatsCarriers(this.categoryId);
            }
        });
        EventBus.$on('disableFilterList', (data) => {
            this.disableFilterLists = data.disableFilter;
        });
    },

    mounted() {
        this.getData(this.categoryId);
        if (this.$route.query['filter[dates]']) {
            this.getStatsCarriers(this.categoryId);
            this.getStatsOffers(this.categoryId);
            this.getOffers = true;
            this.getCarriers = true;
        }
    },

    methods: {
        isDisabledFilter: function () {
            return this.disableFilterCarriers || this.disableFilterOffers || this.disableFilterLists ? this.disableProps : {};
        },
        getData(id) {
            this.isLoaded = false;
            axios
                .get('/lists/categories/' + id + '/data')
                .then((response) => {
                    this.category = response.data.category;
                    this.isAdminOrPublisher = response.data.isAdminOrPublisher;
                    this.getStats();
                })
                .catch(() => {});
        },
        getStats() {
            axios
                .get('/lists/categories/stats?ids=' + this.category.id)
                .then((response) => {
                    this.categoryStats = response.data.stats.find((s) => s.id === this.category.id);
                    this.category = { ...this.category, ...this.categoryStats };
                    this.isLoaded = true;
                })
                .catch(() => {});
        },
        getStatsCarriers(category) {
            this.isCarriersFetching = true;
            this.disableFilterCarriers = true;
            this.getCarriers = true;
            axios
                .get('/lists/categories/' + category + '/carriers-with-stats' + this.filter)
                .then((response) => {
                    this.carriers = response.data.carriers;
                    this.isCarriersFetching = false;
                    this.disableFilterCarriers = false;
                })
                .catch(() => {});
        },
        getStatsOffers(category) {
            this.isOffersFetching = true;
            this.disableFilterOffers = true;
            this.getOffers = true;
            axios
                .get('/lists/categories/' + category + '/offers-with-stats' + this.filter)
                .then((response) => {
                    this.offers = _.orderBy(response.data.offers, 'messages_count', 'desc');
                    this.isOffersFetching = false;
                    this.createToggleObject(_.map(this.offers, 'id'));
                    this.disableFilterOffers = false;
                })
                .catch(() => {});
        },
        createToggleObject: function (ids) {
            let toggle = [];
            ids.forEach((value) => {
                toggle.push({
                    id: value,
                    refreshIcon: false,
                    arrowDownIcon: true,
                    arrowUpIcon: false,
                });
            });
            this.btnToggle = toggle;
            return _.merge(_.keyBy(this.offers, 'id'), _.keyBy(this.btnToggle, 'id'));
        },
        getRouteGroup: function (id) {
            return this.route.group.replace(':id:', id);
        },
        getRouteCategory: function (id) {
            return this.route.tag.replace(':id:', id);
        },
        offersFetching: function () {
            EventBus.$on('clicksOffers', (data) => {
                this.getOffers = data.getOffers;
            });
            this.getStatsOffers();
        },
        carriersFetching: function () {
            EventBus.$on('clicksOffers', (data) => {
                this.getCarriers = data.getCarriers;
            });
            this.getStatsCarriers();
        },
        changeIcon: function (value) {
            return value ? 'fa-minus' : 'fa-plus';
        },
        toggleCollapse() {
            this.collapse = !this.collapse;
        },
    },
};
</script>
